import { fetchUser } from "../service/userService";
import { handlePhotoError } from "../utils/profilePhoto";
import React, { useEffect, useState } from 'react';
import { jwtDecode } from 'jwt-decode'; 
// import logoImg from '../assets/img/logo.png';
import logoImg from '../assets/img/red-logo.svg';
import startImg from '../assets/img/star.svg';
import staricon from '../assets/img/staricon.svg';

import { ArrowRight, Bell, ChevronDown, Coins, FileText, Home, Info, LogOut, Mail, MessageSquareText, Search, SquarePlus, User, } from "lucide-react";

import '../../src/assets/css/style.css';
import { Link, useNavigate, NavLink } from "react-router-dom";
import { useWallet } from '../context/WalletContext';
import { useCurrentUser } from "../hooks/useCurrentUser";

const Header = () => {
  const { walletData, loading } = useWallet ();
  const { firstName, lastName, avatar, user } = useCurrentUser();
  const email = user?.personal_email || "";


  const [isLoggedIn, setIsLoggedIn] = useState(false);
  useEffect(() => {
    if (isLoggedIn) fetchUser().catch(() => {});
  }, [isLoggedIn]);
  const [showWarning, setShowWarning] = useState(false);
  const [userProfilesBox, setUserProfilesBox] = useState(false);
  const [coinsPopupbBox, setCoinsPopupBox] = useState(false);
  const [notificationPopupbBox, setNotificationPopupbBox] = useState(false);

  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [headerSearchTerm, setHeaderSearchTerm] = useState('');

  const navigate = useNavigate();

  const userProfileOpen = (e) => {
    e.stopPropagation();
    setUserProfilesBox(!userProfilesBox);
    setCoinsPopupBox(false);
    setNotificationPopupbBox(false);
  };

  const coinsPopupOpen = (e) => {
     e.stopPropagation();
     setCoinsPopupBox(!coinsPopupbBox);
     setUserProfilesBox(false);
     setNotificationPopupbBox(false);
  };

  const notificationPopupOpen = (e) => {
    e.stopPropagation();
    setNotificationPopupbBox(!notificationPopupbBox);
    setUserProfilesBox(false);
    setCoinsPopupBox(false);
  };


  const toggleMobileMenu = () => {
    setMobileMenuOpen((prev) => !prev);
  };

  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
  };

  useEffect(() => {
    const handleClick = () => {
      setUserProfilesBox(false);
      setCoinsPopupBox(false);
      setNotificationPopupbBox(false);
    };
    
    // const handleClick = () => setUserProfilesBox(false);

    window.addEventListener("click", handleClick);
    return () => window.removeEventListener("click", handleClick);
  }, []);    

   useEffect(() => {
    // setTimeout delays are stored as a 32-bit signed int; anything beyond ~24.8 days
    // overflows and fires immediately instead of waiting. Cap at that max and, for
    // longer-lived tokens, re-check once we're back within range instead of scheduling
    // the real remaining duration directly.
    const MAX_TIMEOUT_MS = 2147483647;

    let logoutTimer;
    let warningTimer;

    const clearTimers = () => {
      clearTimeout(logoutTimer);
      clearTimeout(warningTimer);
    };

    const checkLoginStatus = () => {
      clearTimers();
      const token = localStorage.getItem('token');
      const user = localStorage.getItem('user');
      if (token && user) {
        try {
          const decoded = jwtDecode(token);
          const currentTime = Date.now() / 1000;
          if (decoded.exp && decoded.exp > currentTime) {
            setIsLoggedIn(true);
            const timeLeftMs = (decoded.exp - currentTime) * 1000;

            if (timeLeftMs > MAX_TIMEOUT_MS) {
              logoutTimer = setTimeout(checkLoginStatus, MAX_TIMEOUT_MS);
            } else {
              logoutTimer = setTimeout(handleLogout, timeLeftMs);
              const warningDelay = timeLeftMs - 300000; // 5 minutes before expiry
              if (warningDelay >= 0) {
                warningTimer = setTimeout(() => setShowWarning(true), warningDelay);
              }
            }
          } else {
            handleLogout();
          }
        } catch (error) {
          console.error('Invalid token:', error);
          handleLogout();
        }
      } else {
        setIsLoggedIn(false);
      }
    };
    // Initial check
    checkLoginStatus();
    // Listen to localStorage changes (e.g. after login)
    window.addEventListener("storage", checkLoginStatus);
    return () => {
      window.removeEventListener("storage", checkLoginStatus);
      clearTimers();
    };

  }, []);



  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    window.dispatchEvent(new Event("user-updated"));
    window.dispatchEvent(new Event("storage"));
    setIsLoggedIn(false);
    setMobileMenuOpen(false);
    navigate('/login');
  };

  const homeNavPath = isLoggedIn ? '/feed' : '/';

  const notifications = [
    {
      id: 1,
      icon: <FileText size={24} color="#D72D3D" />,
      bg: "#FDEBEC",
      title:
        'Your survey "Remote Collaboration" has received 25 new responses.',
      time: "10m ago",
    },
    {
      id: 2,
      icon: <Coins size={24} color="#FFB400" />,
      bg: "#FFF6DD",
      title: loading
        ? "Your wallet balance is loading."
        : `${walletData.balance} coins are available in your wallet.`,
      time: "1h ago",
    },
    {
      id: 3,
      icon: <MessageSquareText size={24} color="#D72D3D" />,
      bg: "#FDEBEC",
      title: "John Doe commented on your survey.",
      time: "3h ago",
    },
  ];





  return (
    <header className="header">
      <div className="container-fluid px-lg-5">
        <div className="row align-items-center py-1 innerheaderbox">

          <div className="col-lg-2 col-md-4 col-4 logonamebox order-xl-1">
            <Link to={homeNavPath} className="cnamelogo"><img src={logoImg} alt="Logo" /> <span>Industry & People</span> </Link>
          </div>

          <div className="col-lg-5 col-2 loginprofilebox order-xl-3"> 

            <div className="d-flex gap-4 justify-content-end">

              <div className="search-box d-flex align-items-center justify-content-between gap-3">
                <input
                  type="text"
                  placeholder="Find People & Companies..."
                  className="search-input border-0 bg-transparent w-100"
                  value={headerSearchTerm}
                  onChange={(e) => setHeaderSearchTerm(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                      if (headerSearchTerm.trim()) {
                        navigate(`/search-results?searchTerm=${encodeURIComponent(headerSearchTerm.trim())}`);
                      } else {
                        navigate('/search-results');
                      }
                    }
                  }}
                />

                <button
                  className="search-btn border-0 bg-transparent"
                  onClick={() => {
                    if (headerSearchTerm.trim()) {
                      navigate(`/search-results?searchTerm=${encodeURIComponent(headerSearchTerm.trim())}`);
                    } else {
                      navigate('/search-results');
                    }
                  }}
                >
                  <Search size={20} />
                </button>
              </div>

              {isLoggedIn ? (
                <div className="d-flex right-menu-top ft-14 align-items-center justify-content-end gap-2 sm:gap-3">                

                  <div style={{position:'relative'}}>

                    <div className="d-flex align-items-center gap-4">

                      <div className="totalpoints" onClick={coinsPopupOpen} >
                        <img src={staricon} alt="" />                         
                        <span>{loading ? "..." : `${walletData.balance} Coins`}</span>
                      </div>

                      <div className="notificationbox me-2" onClick={notificationPopupOpen}>
                        <Bell size={26} /> <span>3</span>
                      </div>                     

                    </div>




                  {notificationPopupbBox && (
                      <div className={`userprofilesbox notificationpopupdiv ${notificationPopupbBox ? "coinspopupbox" : ""}`}  onClick={(e) => e.stopPropagation()}>
                        <div className="notification-popup">

                            <div className="notification-arrow"></div>

                            <div className="d-flex justify-content-between align-items-center mb-3">
                              <h5 className="fw-bold mb-0 ft-16">Notifications</h5>

                              <button
                                className="btn p-0 border-0 bg-transparent text-danger ft-15"
                              >
                                Mark all as read
                              </button>
                            </div>

                            <hr className="my-2" />

                            {notifications.map((item) => (
                              <div
                                key={item.id}
                                className="d-flex gap-3 py-3 border-bottom align-items-start"
                              >
                                <div
                                  className="rounded-circle d-flex align-items-center justify-content-center flex-shrink-0"
                                  style={{
                                    width: 48,
                                    height: 48,
                                    background: item.bg,
                                  }}
                                >
                                  {item.icon}
                                </div>

                                <div>
                                  <p className="mb-1 fw-medium">
                                    {item.title}
                                  </p>

                                  <small className="text-secondary">
                                    {item.time}
                                  </small>
                                </div>
                              </div>
                            ))}

                            <button className="w-100 btn btn-red text-decoration-none create_survey rounded-3 ft-15 d-flex align-items-center justify-content-center gap-2">
                              View all notifications
                              <ArrowRight size={18} />
                            </button>

                          </div>
                      </div>
                    )}
                    

                    {coinsPopupbBox && (
                      <div className="userprofilesbox coinspopupbox coins-menu" onClick={(e) => e.stopPropagation()}>
                        <div className="sidebar-content text-center"> 

                          <img src={startImg} alt="" className="coins-menu-icon" />

                          <p className="coins-menu-title">I &amp; P Coin Balance</p>

                          <div className="coins-menu-reward">
                            <span>Available balance</span>
                            <span className="coins-menu-amount"><img src={startImg} alt="" /> <span>{loading ? "..." : `${walletData.balance} Coins`}</span></span>
                          </div>

                          <p className="coins-menu-description">Redeem your coins on your next purchase and save!</p>

                          <div className="coins-menu-actions">
                                <Link
                                  to="/my-wallet"
                                  className="btn btn-outline-dark"
                                >
                                Redeem Now
                                </Link>
                                <Link
                                  to="/my-wallet"
                                  className="btn btn-red"
                                >
                                  Buy Now
                                </Link>
                          </div>  

                        </div>
                      </div>
                    )}
                  </div>

                <div style={{position:'relative'}}>
                  <Link onClick={userProfileOpen} className="userimgname d-flex align-items-center text-white gap-2">
                    <img src={avatar} onError={handlePhotoError} className="rounded-50" alt="User" />
                    <div className="d-flex align-items-center gap-0 sm: gap-1">
                      <span className="usernametext">
                        {firstName.length > 8 ? `${firstName.slice(0, 8)}...` : firstName}
                        {/* Ravi Kum  */}
                      </span>
                      <ChevronDown size={20} />
                    </div>
                  </Link>

                {userProfilesBox && (
                    <div className={`userprofilesbox ${userProfilesBox ? "active" : ""}`}  onClick={(e) => e.stopPropagation()}>
                      <div className="sidebar-content"> 
                        <div className="user-info d-flex align-items-center gap-2 mb-3">
                          <img src={avatar} onError={handlePhotoError} alt="User" className="user-avatar"/>
                          <div className="user-text">
                            <p className="mb-0 fw-bold">{`${firstName} ${lastName}`}</p>
                            {email && <p className="mb-0 text-muted" style={{ overflowWrap: "anywhere", fontSize: "small" }}>{email}</p>}
                          </div>
                        </div>
                        <ul>
                          {/* Hidden per the frontend UI request; retain the existing links. */}
                          <li className="d-none"><Link to="/myprofile" className="active"><i className="bi bi-person-circle"></i> <span>My Profile</span></Link></li>
                          <li className="d-none"><Link href="javascript:void(0)"><i className="bi bi-wallet2"></i> <span> Wallet</span></Link></li>
                          <li className="d-none"><Link href="javascript:void(0)"><i className="bi bi-question-circle"></i> <span> Help & Support</span></Link></li>
                          <li><button className="logoutbtn text-red" onClick={handleLogout}><i className="bi bi-box-arrow-right"></i> Logout</button></li>
                        </ul>
                      </div>
                    </div>
                )}
                </div>

                  {/* <button className="btn btn-red ft-15 fw-600 ms-3" onClick={handleLogout}>Logout</button> */}
                </div>
              ) : (
                <div className="d-flex right-menu-top ft-14 align-items-center justify-content-end gap-4">
                  {/* <Link to="/PreSignup" className="inter whitered">Sign Up</Link> */}
                  <Link to="/signup" state={{ fromJoinUs: true }} className="inter whitered">
                    Sign Up
                  </Link>
                  <Link to="/login" className="btn loginbtn">Log In</Link>
                </div>
              )}
            </div>

          </div>

          <div className="col-lg-5 col-6 mainmenubox order-xl-2">
            <nav className="navbar navbar-expand-xl justify-content-end">
              <button
                className="navbar-toggler"
                type="button"
                onClick={toggleMobileMenu}
                aria-controls="navbarSupportedContent"
                aria-expanded={mobileMenuOpen}
                aria-label="Toggle navigation"
              >
                <span className="navbar-toggler-icon"></span>
              </button>

              <div className={`mobile-overlay ${mobileMenuOpen ? "show" : ""}`}></div>
              <div
                className={`collapse navbar-collapse ${mobileMenuOpen ? 'show' : ''}`}
                id="navbarSupportedContent"
              >
                <button
                  type="button"
                  id="close_mobile_nav"
                  className="ft-18 btn-link text-dark p-0 d-xl-none"
                  onClick={closeMobileMenu}
                  aria-label="Close menu"
                >
                  <i className="bi bi-x-lg"></i>
                </button>



              <div className="mobilelogoname mb-4">
                 <Link to={homeNavPath} className="cnamelogo"><img src={logoImg} alt="Logo" /> <span className="graytext ft-16">Industry & People</span> </Link>
              </div>


                <ul className="navbar-nav gap-4 mx-auto">
                  <li className="nav-item">
                    <NavLink to={homeNavPath} className="nav-link" onClick={closeMobileMenu}><Home size={18} /> Home</NavLink>                    
                  </li>
                  <li className="nav-item">
                    <NavLink to="/about" className="nav-link" onClick={closeMobileMenu}><Info size={18} /> About</NavLink>
                  </li>
                  <li className="nav-item">
                    <NavLink to="/create-survey" className="nav-link" onClick={closeMobileMenu}><SquarePlus size={18} /> Create Survey</NavLink>
                  </li>                   
                   <li className="nav-item">
                    <NavLink to="/contactus" className="nav-link" onClick={closeMobileMenu}><Mail size={18} /> Contact Us</NavLink>
                  </li>

                  {/* <li className="nav-item">
                    <NavLink to="/contactus" className="nav-link" onClick={closeMobileMenu}><User size={18} /> My Profile</NavLink>
                  </li> */}
                </ul>

                <div className="d-xl-none mt-4">
                  {isLoggedIn ? (
                    <div className="d-flex flex-column gap-3">
                      <Link to="/myprofile" className="nav-link px-0" onClick={closeMobileMenu}>
                        <User size={18} /> My Profile
                      </Link>

                      <button type="button" className="nav-link px-0 text-red border-top pt-4 mt-2 btn btn-link text-decoration-none text-start" onClick={handleLogout}>
                        <LogOut size={18} /> Logout
                      </button>


                      {/* <button className="btn loginbtn ft-15 fw-600" onClick={handleLogout}>
                        Logout
                      </button> */}
                    </div>
                  ) : (
                    <div className="d-flex flex-column gap-4">
                      <Link to="/signup" state={{ fromJoinUs: true }} className="inter whitered" onClick={closeMobileMenu}>
                        Sign Up
                      </Link>
                      <Link to="/login" className="btn loginbtn ft-15 fw-600" onClick={closeMobileMenu}>
                        Log In
                      </Link>
                    </div>
                  )}
                </div>
              </div>
            </nav>
          </div>          

        </div>
        {showWarning && (
          <div className="alert alert-warning text-center mt-2" role="alert">
            Your session expired. Login!
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
